import Grid from "@material-ui/core/Grid";
import { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { AccountDetailsExplanation } from "@common/Layout/AccountDetailsExplanation";
import { AccountDetailsLayout } from "@common/Layout/AccountDetailsLayout";
import replaceSIM from "@static/img/manageSim/replaceSIM.png";
import "@features/ManageSim/css/manageSim.scss";
import { ReplacementSim } from "@features/ManageSim/ReplacementSim";
import { ActivateSim } from "@features/ManageSim/ActivateSim";
import { SelectedServiceContext } from "@context/ISelectedContext";

export const ManageSimPage = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const { t } = useTranslation("sim");

    return (
        <AccountDetailsLayout requireNumberSelection title={t("replaceActivateSim")}>
            <Grid container spacing={4}>
                {!selectedService && (
                    <AccountDetailsExplanation
                        alt="replace or activate my sim"
                        src={replaceSIM}
                        texts={[t("simStep1"), t("simStep2"), t("simStep3")]}
                        title={t("simExplanationTitle")}
                    />
                )}
                {selectedService && (
                    <Fragment>
                        <Grid item xs={12}>
                            <ReplacementSim selectedService={selectedService} />
                        </Grid>
                        <Grid item xs={12}>
                            <ActivateSim />
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        </AccountDetailsLayout>
    );
};
